import { GridValidRowModel } from '@mui/x-data-grid-pro';

import {
  SourcingCaseStatusChip,
  SourcingCaseStatusUnion,
} from '~/components/SourcingCaseStatusChip/SourcingCaseStatusChip';

export interface SourcingCaseStatusChipCellProps<R extends GridValidRowModel = any> {
  status: SourcingCaseStatusUnion;
  row?: R;
}

export const SourcingCaseStatusChipCell = <R extends GridValidRowModel = any>({
  status,
}: SourcingCaseStatusChipCellProps<R>) => {
  // div wrapper needed to display chip correctly
  return (
    <div>
      <SourcingCaseStatusChip status={status} />
    </div>
  );
};
